import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";

const moduleName = "employee";

store.registerModule(moduleName, {
  namespaced: true,
  state: {},
  actions: {
    // 获取员工列表
    async getEmployee({ commit }, payload) {
      var result = await api.get(
        `/api/User/Page/?${queryString.stringify(payload)}`
      );
      return result.data;
    },
  },
  mutations: {},
  getters: {},
});

export default moduleName;
